import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../../MainCSS.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import "aos/dist/aos.css";
import { DeleteJobWorkerProcessMaster, GetJobWorkerProcessMaster, SaveJobWorkerProcessMaster, UpdateJobWorkerProcessMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';

const JobWorkerProcessMaster = () => {
   const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };
 
    const [errors, setErrors] = useState({
       processDescription: "",
       remarks: "",
   
     });
   
     const [pageSize, setPageSize] = useState(10);
     const [filteredData, setFilteredData] = useState([]);
     const [currentPage, setCurrentPage] = useState(1);
     const [totalEntries, setTotalEntries] = useState(0);
     const [jobWorkerProcessId, setJobWorkerProcessId] = useState("");
     const [processDescription, setProcessDescription] = useState("");
     const [remarks, setRemarks] = useState("");
   
     const [allProcessDescription, setAllProcessDescription] = useState([]);
     const [submitButton, setSubmitButton] = useState(true);
     const [updateButton, setUpdateButton] = useState(false);
   
     //======Search data from table===============
     const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
    
      const filtered = allProcessDescription.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );
    
      setFilteredData(filtered);
      setTotalEntries(filtered.length);
      setCurrentPage(1);
    };
     //==========Pagination=======================
     const handlePageSizeChange = (value) => {
       setPageSize(value);
     };
      // ==============Get table data================
      let isProcessDescriptionMasterFetched = false;
      useEffect(() => {
        if (isProcessDescriptionMasterFetched) return;
            fetchProcessDescriptionMaster();
        isProcessDescriptionMasterFetched = true;
      }, []);
    
      let isError = false;
    
      const fetchProcessDescriptionMaster = async () => {
        try {
       
           const response = await axios.get(GetJobWorkerProcessMaster ,commonHeaders);
          if (response.data !== null) {
            setAllProcessDescription(response.data);
            setFilteredData(response.data); // Set initial filtered data as the fetched data
            setTotalEntries(response.data.length); // Set the total number of entries
          }
        } catch (error) {
          if (!isError) {
            console.error("Error fetching Job Work Process Master data:", error);
            toast.error("Failed to fetch Job Work Process Master data");
            isError = true; // Set the flag to prevent double toast
          }
        }
      };
      
    
   
    //  const columns = [
    //    {
    //      title: "Sr.No.",
    //      dataIndex: "",
    //      key: "index",
    //      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    //    },
     
    //    {
    //      title:"Job Work Process",
    //      dataIndex: "description",
    //      key: "description",
    //    },
    //    {
    //      title: "Remarks",
    //      dataIndex: "remarks",
    //      key: "remarks",
    //    },
    
    //    {
    //      title: "Actions",
    //      key: "actions",
    //      render: (text, record) => (
    //        <div>
    //          <span
    //            type="submit"
    //            style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
    //          onClick={() => handleEditDataButton(record)}
    //          >
    //            <i class="fa-solid fa-pen-to-square"></i>
    //          </span>
    //          <span
    //            type="submit"
    //            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
    //            onClick={() => handleDeleteData(record)}
    //          >
    //            <i class="fa-solid fa-trash"></i>
    //          </span>
    //        </div>
    //      ),
    //    },
    //  ];
   

    const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Job Work Process",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => a.description.localeCompare(b.description),
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
    sorter: (a, b) => a.remarks.localeCompare(b.remarks),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
    ];

     const components = {
       header: {
         cell: ({ children, ...restProps }) => (
           <th
             {...restProps}
             style={{
               backgroundColor: "#023e7d",
               color: "#fff",
               padding: "10px",
               fontSize: "13px",
               borderRadius: "0px",
             }}
           >
             {children}
           </th>
         ),
       },
       body: {
         row: ({ children, ...restProps }) => (
           <tr
             {...restProps}
             style={{
               backgroundColor: "#f0f7fd",
             }}
           >
             {children}
           </tr>
         ),
         cell: ({ children, ...restProps }) => (
           <td
             {...restProps}
             style={{
               padding: "8px",
             }}
           >
             {children}
           </td>
         ),
       },
     };
       // ========Submit data to table==============
       const handleSubmit = async () => {
         let isValid = true;
         const errorObj = {};
     
         if (!processDescription.trim()) {
           isValid = false;
           errorObj.processDescription = "Die Assembly Type is required *";
         }
         
         if (!remarks.trim()) {
           isValid = false;
           errorObj.remarks = "Remarks is required *";
         }
     
     
         setErrors(errorObj); // Set error messages
     
         if (!isValid) return;
     
         const bodyData = {
           description: processDescription,
           remarks:remarks,
       
         };
     
         try {
           const response = await axios.post(SaveJobWorkerProcessMaster, bodyData ,commonHeaders);
      
           if (response.data === "CREATED") {
             toast.success("Job Work Process added successfully!");
             fetchProcessDescriptionMaster();
             handleCancel();
           } else if (response.data === "ALREADYEXISTED") {
             toast.warn("Job Work Process already exist!");
             //handleCancel();
           }
         } catch (error) {
           console.error("Error during API call:", error);
           toast.error("Error occurred while submitting data");
         }
       };
   //==================== Handle Cancel button =====================
       const handleCancel = () => {
         setUpdateButton(false);
         setSubmitButton(true);
         setRemarks("");
         setProcessDescription("");
         setErrors("");
       };
     // ========Update data from table============
     const handleEditDataButton = (item) => {
       setUpdateButton(true);
       setSubmitButton(false);
       window.scrollTo(0, 0);
       setProcessDescription(item.description);
       setRemarks(item.remarks);
   
       setJobWorkerProcessId(item.id);
     };
     const handleUpdate = async () => {
       if (!processDescription) {
         toast.warn("Please enter Process Description!");
         return;
       }
       if (!remarks) {
         toast.warn("Please enter Remarks!");
         return;
       }
   
   
      
       const bodyData = {
         id:jobWorkerProcessId,
         description: processDescription,
         remarks:remarks,
     
       };
   
       try {
       const response = await axios.put(UpdateJobWorkerProcessMaster, bodyData ,commonHeaders);
       
         if (response.data === "UPDATED") {
           toast.success("Job Work Process updated successfully!");
           fetchProcessDescriptionMaster();
           handleCancel();
         } else if (response.data === "ALREADYEXISTED") {
           toast.warn("Job Work Process  already exist!");
           //handleCancel();
         }
       } catch (error) {
         console.error("Error during API call:", error);
         toast.error("Error occurred while updating data");
       }
     };
     //============================== Delete data from table ======================================
     const handleDeleteData = async (item) => {
       const confirmDelete = window.confirm(
         `Are you sure you want to delete the Die Assembly  "${item.description}"?`
       );
       if (!confirmDelete) return;
   
       try {
         const response = await axios.delete(
           `${DeleteJobWorkerProcessMaster}?id=${item.id}`,commonHeaders
         );
      
         if (response.data === "DELETED") {
           toast.success("Job Work Process deleted successfully!");
           fetchProcessDescriptionMaster();
           handleCancel();
         }
       } catch (error) {
         console.error("Error during delete operation:", error);
         toast.error("Error occurred while deleting ");
       }
     };
   return (
        <div className="px-5 py-3">
          <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
            <div className="col-12">
        <div className="row px-md-5 mt-3 p-2 ">
        
        <div className="row p-0 m-0">
        <div className="col-12 col-lg-4"></div>
        <div className="col-12 col-lg-4">
        <div className="row p-0 m-0">
              
          
              <div className="col-12 py-1">
                <label className="labels">Process Description</label>
                <Input
                  value={processDescription}
                  onChange={(e) => setProcessDescription(e.target.value)}
                    maxLength="250"
                  placeholder="Enter Type"
                  style={{ width: '100%' }}
                />
                {errors.processDescription && <div className="errorField">{errors.processDescription}</div>}
              </div>
        
              <div className="col-12 py-1">
                <label className="labels">Remarks</label>
                <Input.TextArea
                  value={remarks}
                  maxLength="250"
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Enter Remarks"
                  style={{ width: '100%' }}
                />
                {errors.remarks && <div className="errorField">{errors.remarks}</div>}
              </div>
          </div>
          </div>
          </div>
              
                  <div className="col-12 text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                        onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    {submitButton && (
                      <Button
                        type="submit"
                        className="SubmitBtn mx-1"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    )}
                    {updateButton && (
                      <Button
                        type="submit"
                        className="UpdateBtn mx-1"
                        onClick={handleUpdate}
                      >
                        Update
                      </Button>
                    )}
                  </div>
          
            <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div></div>
          
            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div className="col-12 py-3 shadow border" style={{ backgroundColor: "white" }}>
                <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: "center" }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>
          
                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>
          
                <div style={{ backgroundColor: "white" }}>
                  <Table
                    bordered
                    style={{ padding: "0px 20px", overflowX: "auto" }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
            </div>
          </div>
       </div>
   )
}

export default JobWorkerProcessMaster